import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Download } from "lucide-react";
import { COMPANY } from "../lib/constants";
import useSiteSettings, { profilePdfUrl } from "../lib/useSiteSettings";
import WhatsAppIcon from "./WhatsAppIcon";

export default function CTASection({
  title,
  description,
  primaryTo = "/submit",
  primaryLabel = "Submit Requirement",
  showDownload = true,
  showWhatsApp = true,
}) {
  const settings = useSiteSettings();
  const pdf = profilePdfUrl(settings);
  const waLink = `https://wa.me/${COMPANY.whatsapp}`;
  return (
    <section className="section">
      <div className="container-x">
        <div className="hero-gradient rounded-2xl p-8 md:p-12 text-white relative overflow-hidden">
          <div className="max-w-2xl">
            <div className="kicker text-[var(--melopa-gold-soft)] mb-3">Engage With Us</div>
            <h3 className="text-2xl md:text-3xl font-bold leading-tight">{title}</h3>
            <p className="text-white/80 mt-3">{description}</p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link to={primaryTo} className="btn-gold" data-testid="cta-primary">
                {primaryLabel} <ArrowRight className="w-4 h-4" />
              </Link>
              {showDownload && (
                pdf ? (
                  <a href={pdf} target="_blank" rel="noreferrer" className="btn-outline-white" data-testid="cta-download">
                    <Download className="w-4 h-4" /> Download Company Profile
                  </a>
                ) : (
                  <Link to="/downloads" className="btn-outline-white" data-testid="cta-download">
                    <Download className="w-4 h-4" /> Download Company Profile
                  </Link>
                )
              )}
              {showWhatsApp && (
                <a href={waLink} target="_blank" rel="noreferrer" className="btn-outline-white" data-testid="cta-whatsapp">
                  <WhatsAppIcon className="w-4 h-4" /> WhatsApp
                </a>
              )}
            </div>
          </div>
          <div className="absolute -right-16 -bottom-16 w-72 h-72 rounded-full bg-[var(--melopa-gold)]/25 blur-3xl" />
        </div>
      </div>
    </section>
  );
}
